/**
 * Google Analytics Component
 * Placeholder for Google Analytics integration
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    console.log('Page view:', location.pathname);
    
    // Add actual Google Analytics tracking here
    // Example: window.gtag('config', 'GA_MEASUREMENT_ID', { page_path: location.pathname });
  }, [location]);

  return null;
};

export default GoogleAnalytics;
